import { Button, Divider, makeStyles, TextField, Dialog } from '@material-ui/core'
import React, { useCallback, useEffect, useState } from 'react'
import axios from "axios";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import Loader from '../loader/Loader';
import { toast } from 'react-toastify';


const useStyles = makeStyles({
  root: {
    width: "100%",
    overflowX: "auto",
  },
  table: {
    minWidth: 650,
  },
  tableHead: {
    background: "#3f51b5",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "darkcyan !important",
    },
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "lightgrey !important",
    },
  },
  headerCell: {
    color: "white",
  },
});

const FixBalance = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [players, setPlayers] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);

    const classes = useStyles();
    const [renderShowsTotal, setRenderShowsTotal] = useState(true);
    const [showInfo, setShowInfo] = useState(true);

    const [openDialog, setOpenDialog] = useState(false);
    const [dialogData, setDialogData] = useState([]);

  const requestData = useCallback(() => {
    setIsLoading(true);
    const url =
      process.env.REACT_APP_API2_URL +
      "/Player/GetPlayerByStatus?status=E"
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        setPlayers(data);
        setIsLoading(false);
      });
  }, []);

    useEffect(()=>{
      requestData();
    },[requestData])
    


      const handleButtonClick = () => {
        console.log("Selected Rows:", selectedRows);
        const req = selectedRows.map(item => ({
            Player: item.player
        }));
        axios({
            method: "post",
            url: process.env.REACT_APP_API2_URL + "/Player/FixPlayerBalance",
            data: req,
          }).then((response) => {
            if(response.data.length > 0){
                setDialogData(response.data);
                setOpenDialog(true);
                toast.success(`Balance fixed successfully`);
            }else{
                toast.error(`There was no data to recalculate.`);
            }
          });
      };

      const options = {
        page: 1,
        sizePerPageList: [
          { text: "15", value: 15 },
          { text: "50", value: 50 },
          { text: "500", value: 500 },
          { text: "1000", value: 1000 },
        ],
        sizePerPage: 10,
        pageStartIndex: 1,
        paginationSize: 3,
        prePage: "Prev",
        nextPage: "Next",
        firstPage: "First",
        lastPage: "Last",
        paginationShowsTotal: renderShowsTotal,
        paginationPosition: "bottom",
      };

      const selectRow = {
        mode: "checkbox",
        clickToSelect: true,
        onSelect: (row, isSelect) => {
          setSelectedRows(prev =>
            isSelect ? [...prev, row] : prev.filter(r => r.idPlayer !== row.idPlayer)
          );
        },
        onSelectAll: (isSelect, rows) => {
          setSelectedRows(isSelect ? rows : []);
        }
      };

      const dataFormatter = (cell, row) => {
        if (typeof cell === 'string') {
          return cell.replace("T", " ");
        }
        return cell;
      };
  return (
    <div className="MuiTable-root2">
        <h2>Fix Balance</h2>
        <Divider className="mt-4 mb-4"></Divider>
        {/* {
            isLoading 
            ?  <div className='flex items-center mx-1'> <span className='text-xs italic'> Loading agents... </span><Loader height={50} width={50} ></Loader></div>
            : <div className=''>
                <Autocomplete
                    className='w-[300px]'
                    options={agents} 
                    getOptionLabel={(option) => option.Agent} 
                    value={selected}
                    disabled={agents.length < 1}
                    onChange={(event, newValue) => setSelected(newValue)}
                    renderInput={(params) => (
                        <TextField {...params} label="Select an agent" variant="outlined" />
                    )}
                    />
            </div>
        } */}
        {
          isLoading ? <Loader height={700} width={700}></Loader>
          : <div className=" mt-4">
              <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  className='mb-3 mt-3'
                  onClick={handleButtonClick}
              >
                  Fix Balance
              </Button>
              <Table className={classes.table} aria-label="simple table">
                <TableBody className={showInfo ? "show-table" : "hide-table"}>
                  {players && (
                    <div>
                      <BootstrapTable
                        pagination
                        options={options}
                        selectRow={selectRow}
                        version="4"
                        data={players}
                        hover
                      >
                        <TableHeaderColumn dataField="idPlayer" isKey hidden>
                          Field A
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="player"  filter={{ type: "TextFilter", delay: 1000 }}>
                          Player
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="name"  filter={{ type: "TextFilter", delay: 1000 }}>Name</TableHeaderColumn>
                        <TableHeaderColumn dataField="currency">Currency</TableHeaderColumn>
                        <TableHeaderColumn dataField="creditLimit">CreditLimit</TableHeaderColumn>
                        {/* <TableHeaderColumn dataField="Balance">Balance</TableHeaderColumn> */}
                        <TableHeaderColumn dataField="lastWager" dataFormat={dataFormatter}>LastWager</TableHeaderColumn>
                      
                      </BootstrapTable>
                    </div>
                  )}
                </TableBody>
              </Table>
            </div>
      }
    <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="md" fullWidth>
        <div style={{ padding: "20px" }}>
          <h3>Fix Player Balance Results:</h3>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th>IdPlayer</th>
                <th>Player</th>
                <th>Change</th>
                <th>Old Value</th>
                <th>New Value</th>
                <th>Last Modification</th>
              </tr>
            </thead>
            <tbody>
              {dialogData.map((row, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: row.idPlayer === -1 ? "#f8d7da" : "transparent", // rojo suave
                    color: row.idPlayer === -1 ? "#721c24" : "inherit",
                  }}
                >
                  <td>{row.idPlayer}</td>
                  <td>{row.player}</td>
                  <td>{row.change}</td>
                  <td>{row.oldValue}</td>
                  <td>{row.newValue}</td>
                  <td>{typeof row.lastMoficiation === 'string'
                      ? row.lastMoficiation.replace('T', ' ').split('.')[0]
                      : ''}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Dialog>
    </div>
  )
}

export default FixBalance
